import moment from 'moment'

export function utcToLocal (date: string): string {
    return moment.utc(date).local().format('yyyy-MM-DDTHH:mm')
}
